import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchInterventionComment(params) {
  try {
    const interventionComment = yield call(function() {
      return Api.get(`/intervention/${params.id}/comment`)
    });
    yield put({type: 'FETCH_INTERVENTION_COMMENT.SUCCESS', interventionComment});
  } catch (error) {
    yield put({type: 'FETCH_INTERVENTION_COMMENT.FAILURE', error});
  }
}
function* saveInterventionComment(params) {
  try {
    const interventionComment = yield call(function() {
      return Api.post(`/intervention/${params.id}/comment`, params.body)
    });
    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
    yield put({type: 'FETCH.INTERVENTION_STATUS.REQUEST', id:params.id});
    yield put({type: 'SAVE_INTERVENTION_COMMENT.SUCCESS', interventionComment});
  } catch (error) {
    yield put({type: 'SAVE_INTERVENTION_COMMENT.FAILURE', error});
  }
}

export function* watchFetchInterventionComment() {
  yield takeEvery('FETCH_INTERVENTION_COMMENT.REQUEST', fetchInterventionComment)
}

export function* watchSaveInterventionComment() {
  yield takeEvery('SAVE_INTERVENTION_COMMENT.REQUEST', saveInterventionComment)
}



// WEBPACK FOOTER //
// ./src/sagas/interventionComment.js